export default {
  ORG_API: process.env.REACT_APP_GATEWAY_API + '/org',
  AUTH_API: process.env.REACT_APP_GATEWAY_API + '/user',
  DEVICE_API: process.env.REACT_APP_GATEWAY_API + '/device',
  SCHEDULER_API: process.env.REACT_APP_GATEWAY_API + '/scheduler',
  CLIENT_API: process.env.REACT_APP_GATEWAY_API + '/client',
  PRODUCT_API: process.env.REACT_APP_GATEWAY_API + '/product',
};

export const ROUTE_FLAG = {
  ENABLE_CLIENT_MANAGEMENT: process.env.REACT_APP_ENABLE_CLIENT_MANAGEMENT === 'true',
  ENABLE_PRODUCT_MANAGEMENT: process.env.REACT_APP_ENABLE_PRODUCT_MANAGEMENT === 'true',
  ENABLE_DEVICE_MAPPING_TUYA: process.env.REACT_APP_ENABLE_DEVICE_MAPPING_TUYA === 'true',
  ENABLE_DEVICE_MAPPING_PANORAMIC: process.env.REACT_APP_ENABLE_DEVICE_MAPPING_PANORAMIC === 'true',
  ENABLE_DEVICE_MAPPING_LUTRON: process.env.REACT_APP_ENABLE_DEVICE_MAPPING_LUTRON === 'true',
  ENABLE_USER_SSA_SCHOOL: process.env.REACT_APP_ENABLE_USER_SSA_SCHOOL === 'true',
};

export const NOTIFICATION_METHODS = [
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Slack',
    value: 'slack',
  },
  {
    label: 'None',
    value: 'none',
  },
];
